import { useState, VFC } from 'react'
import { useNotification } from 'src/api/notification'
import {
  HeaderAIPickIcon,
  HeaderContentIcon,
  HeaderContributionIcon,
  HeaderEventIcon,
  HeaderExhibitionIcon,
  HeaderFeedbackIcon,
  HeaderGuideIcon,
  HeaderMessageIcon,
  HeaderPremiumContributionIcon,
  HeaderRequestBoxIcon,
  HeaderSearchIcon,
} from 'src/assets/svgs'
import { UserIcon } from 'src/components/Image/UserIcon'
import { EMPTY_NOTIFICATION } from 'src/models/Notification'
import {
  CONTENTS,
  CONTRIBUTIONS,
  EVENTS,
  EXHIBITIONS,
  FEEDBACKS,
  GUIDE,
  MESSAGES,
  NEEDS,
  PREMIUM_CONTRIBUTIONS,
  RECOMMEND,
  REQUEST_BOX,
} from 'src/utils/routes'
import styled from 'styled-components'
import { MemberHeaderContentProps } from '../types'
import { DrawerMenu } from './DrawerMenu'
import { HeaderWrapper } from './HeaderWrapper'
import { NavigationItem } from './NavigationItem'

export const MemberWideHeader: VFC<MemberHeaderContentProps> = ({ user }) => {
  const [isMenuOpen, setMenuOpen] = useState(false)
  const toggleMenu = () => setMenuOpen(!isMenuOpen)
  const { data = EMPTY_NOTIFICATION } = useNotification()
  return (
    <HeaderWrapper member>
      <NavigationItem
        href={RECOMMEND}
        Icon={HeaderAIPickIcon}
        label="今日のAIピック"
      />
      {(user.plan.isAdminRole || user.plan.paid) && (
        <NavigationItem
          href={NEEDS}
          Icon={HeaderSearchIcon}
          label="決裁者を探す"
        />
      )}
      <NavigationItem
        href={PREMIUM_CONTRIBUTIONS}
        Icon={HeaderPremiumContributionIcon}
        label="案件を探す"
        isNew
      />
      <NavigationItem
        href={EXHIBITIONS}
        Icon={HeaderExhibitionIcon}
        label="発注先を探す"
        isNew
      />
      <NavigationItem
        href={CONTENTS}
        Icon={HeaderContentIcon}
        label="経営コラム"
        isNew
      />
      <NavigationItem
        href={CONTRIBUTIONS}
        Icon={HeaderContributionIcon}
        label="掲示板"
        unreadCount={data.contributionCount}
      />
      <NavigationItem href={EVENTS} Icon={HeaderEventIcon} label="イベント" />
      <NavigationItem
        href={REQUEST_BOX}
        Icon={HeaderRequestBoxIcon}
        label="つながり一覧"
      />
      <NavigationItem
        href={MESSAGES}
        Icon={HeaderMessageIcon}
        label="メッセージ"
        unreadCount={data.messageCount}
      />
      <NavigationItem
        href={FEEDBACKS}
        Icon={HeaderFeedbackIcon}
        label="アポイント・評価"
      />
      <NavigationItem href={GUIDE} Icon={HeaderGuideIcon} label="ガイド" />
      <button onClick={toggleMenu}>
        <StyledUserIcon src={user.profile.iconSrc} size="40px" />
      </button>
      <DrawerMenu
        isOpen={isMenuOpen}
        user={user}
        messageSendableCount={data.messageSendableCount}
      />
    </HeaderWrapper>
  )
}

const StyledUserIcon = styled(UserIcon)`
  margin-left: 20px;
  margin-bottom: 10px;
`
